import React, { createContext, useContext, useState, useEffect } from 'react';

const PredictStateContext = createContext();

export const usePredictState = () => {
  const context = useContext(PredictStateContext);
  if (!context) {
    throw new Error('usePredictState must be used within a PredictStateProvider');
  }
  return context;
};

export const PredictStateProvider = ({ children }) => {
  // State that needs to persist across navigation
  const [file, setFile] = useState(null);
  const [sensorDataId, setSensorDataId] = useState(null);
  const [isUploading, setIsUploading] = useState(false);
  const [uploadSuccess, setUploadSuccess] = useState(false);
  const [uploadError, setUploadError] = useState('');
  const [showChart, setShowChart] = useState(false);
  const [selectedString, setSelectedString] = useState('string1');
  const [selectedModel, setSelectedModel] = useState('model1');

  // NO PERSISTENCE - always start fresh
  useEffect(() => {
    console.log('🔄 Starting with clean state - no persistence');
    // Clear any old saved state
    localStorage.removeItem('gepredict_persistent_state');
  }, []);

  // NO SAVING TO localStorage - always fresh state
  // State is only kept in memory during the session

  // Clear all state (for when user wants to start fresh)
  const clearState = () => {
    setFile(null);
    setSensorDataId(null);
    setIsUploading(false);
    setUploadSuccess(false);
    setUploadError('');
    setShowChart(false);
    setSelectedString('string1');
    setSelectedModel('model1');
    localStorage.removeItem('gepredict_persistent_state');
    console.log('Predict state cleared');
  };

  const value = {
    // State
    file,
    sensorDataId,
    isUploading,
    uploadSuccess,
    uploadError,
    showChart,
    selectedString,
    selectedModel,
    
    // Setters
    setFile,
    setSensorDataId,
    setIsUploading,
    setUploadSuccess,
    setUploadError,
    setShowChart,
    setSelectedString,
    setSelectedModel,
    
    // Actions
    clearState
  };

  return (
    <PredictStateContext.Provider value={value}>
      {children}
    </PredictStateContext.Provider>
  );
}; 